<template>
    <div class="body-width divcss5">
      <div>
        <div class="div-row div-bottom news-Medium-24">
            辽宁省委书记、省人大常委会主任郝鹏一行到海事大学进行调研并对大连海大智龙科技有限公司进行参观指导
          <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
        </div>
          <div class="div-text-left news-Regular-14b6">
              <span>2023-11-16</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
             </div>
        <div class="div-line  divcss5">
        </div>
        <div class="div-row div-bottom30">
            <p class="indentation0">
                辽宁省委书记、省人大常委会主任郝鹏在我校调研时强调
              </p>
              <p class="indentation0">
                加快建设世界一流海事大学
              </p>
              <p class="indentation0">
                更好服务海洋经济强省和交通强国建设
              </p>
            <p class="indentation">
                11月13日，省委书记、省人大常委会主任郝鹏来到我校，就深入贯彻落实习近平总书记在新时代推动东北全面振兴座谈会上重要讲话精神，按照省委十三届六次全会安排部署，加快以科技创新推动产业创新，支持学校建设世界一流海事大学，更好服务辽宁海洋经济强省和交通强国建设进行专题调研。
              </p>
            </div>
        <div class="div-row">
          <div class="  div-top box2">
            <div class="div-margin " >
              <img src="../../../assets/images/news27/1.png" />
            </div>
          </div>
        </div>

        <div class="div-row div-top30 ">
            <p class="indentation1">
                11月13日，省委书记、省人大常委会主任郝鹏到大连海事大学调研并与大学生交流学习情况
          </p>
          </div>

        <div class="div-row div-top30 ">
            <p class="indentation div-top0">
                郝鹏来到大连海大智龙科技有限公司，该公司是我校航海模拟器研发团队创立的企业，其研发生产的航海模拟器系列产品国内市场占有率位居首位。郝鹏走进企业产品展示区，详细了解各类最新装备研发应用情况。他勉励企业要主动对接国家战略需求，加大研发投入，加快更多科研成果落地转化，更好赋能辽宁海洋产业创新发展。
          </p>
          </div>
  
        <div class="div-row">
          <div class=" div-top box2">
            <div class="div-margin " >
              <img src="../../../assets/images/news27/2.png" />
            </div>
          </div>
        </div>

        <div class="div-row div-top30 ">
            <p class="indentation1">
                11月13日，省委书记、省人大常委会主任郝鹏到大连海大智龙科技有限公司调研
          </p>
          </div>

        <div class="div-row div-top30 ">
          <p class="indentation div-top0">
            大连东北亚国际航运中心研究院是我校与大连市共建的新型智库。近年来，在综合交通、绿色港航、航运金融大数据平台建设等方面取得了一批高水平研究成果。郝鹏认真听取汇报，对研究院聚焦大连东北亚国际航运中心建设开展研究，破解系列难点问题表示肯定。他说，辽宁是沿海省份，区位优势明显。希望研究院加快港口与航运等大数据平台建设，积极开展更多战略规划、决策咨询等前瞻性研究，为大连东北亚国际航运中心和东北海陆大通道建设贡献更多智慧和力量。
        </p>
        <p class="indentation div-top0">
            在学校新图书馆内，郝鹏先后来到学术报告厅、预约自习室和特色多媒体区，了解学校校园建设、在校学生学习生活等情况，并与正在图书馆内自习的学生亲切交流。郝鹏说，大学是人生中最宝贵的一段经历，要珍惜当前优越的学习生活环境，刻苦读书、不负韶华，努力成长成为国家栋梁之材，用所学所能回报社会、服务人民。辽宁有着良好的发展态势和发展机遇，欢迎大家毕业后扎根辽宁、建设辽宁。
        </p>
        <p class="indentation div-top0">
            郝鹏还来到辽宁省港口与物流枢纽数字化重点实验室，听取港口物流控制系统研发应用情况介绍。他勉励实验室负责同志要进一步加强新兴交叉学科研究，以智慧、绿色为主攻方向，联合航运领军企业开展科研攻关，推动大连现代航运服务业高质量发展，助力辽宁交通强省建设。
        </p>
        <p class="indentation div-top0">
            郝鹏在调研中指出，大连海事大学肩负着建设交通强国的历史使命，学科特色鲜明、优势突出，在国际海事领域具有广泛影响力，是我省高等教育一张靓丽的名片。多年来，学校在交通运输部党组的领导和支持下，主动服务国家重大战略，积极融入地方经济发展，着力推动学科、人才、科研、产业良性互动，为东北、辽宁振兴发展作出了重要贡献。希望学校抓住新时代推动东北全面振兴带来的难得机遇，紧扣打造新时代“六地”目标定位，围绕技术创新推动转型升级，进一步发挥特色优势，与辽宁相关部门、企业和科研院所开展协同创新，积极参与产学研合作，支持辽宁大力发展海洋工程装备与船舶制造等优势产业，助力辽宁海洋经济强省建设；着力提高国际化办学水平，加大高层次领军人才引育力度，更好服务国家海洋事业发展。大连海事大学坐落在辽宁大连，全力支持好学校办学是辽宁应尽的责任与义务。省委、省政府将积极推动省部共建，更好满足学校办学需求，强化人才服务保障、各类要素保障，努力营造更优创新环境，助力学校早日建设成为世界一流海事大学。
        </p>
        <p class="indentation div-top0">
            省及大连市领导熊茂平、霍步刚、温雪琼参加调研。调研期间，学校党委书记许民强、校长单红军就学校工作进行了汇报。
        </p>
        <p class="indentation div-top0">
          <a href="https://news.dlmu.edu.cn/info/1021/61187.htm" target="_blank">此内容来自：辽宁省委书记、省人大常委会主任郝鹏一行到我校调研-大连海事大学新闻网 (dlmu.edu.cn)</a>
      </p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    export default {
      data() {
        return {
          isflag1: true,
          isflag2: false,
          isflag3: false
        };
      },
      mounted() {
        window.addEventListener('scroll', this.handleScroll)
      },
      methods: {
        handleScroll() {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
            // alert(scrollTop)
            this.isflag2 = true;
          }
          if (parseInt(scrollTop) >= 1200) {
            this.isflag3 = true;
          }
  
        },
        destroyed() {
          window.removeEventListener('scroll', this.handleScroll)
        },
      },
    };
  
  </script>
  
  <style scoped>
    .fl {
      float: right;
      margin-right: 20px;
    }
  
    .fy {
      text-align: center;
      margin-top: 30px;
    }
  
    .title {
      height: 100%;
    }
  
    .div-width {
      width: 75%;
    }
  
  
  
    .div-line {
      background: #E6E6E6;
      height: 1px;
      width: 100%;
  
    }
  
    .div-bottom10 {
      padding-top: 10px;
    }
  
    .div-bottom30 {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  
    .div-top30 {
      padding-top: 30px;
    }
  
    img {
      vertical-align: middle;
      border-style: none;
      width: 95%; 
      border-radius: 10px;
    }
    .indentation0{
        font-size: large;
        font-weight: bold;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/contentcoms/news2023/news27.vue